module.exports = __webpack_public_path__ + "img/zhao.6cb1b452.jpg";